import React from 'react';
import './PageWrapper.css';

interface PageWrapperProps {
  title: string;
  children: React.ReactNode;
  containerClassName?: string;
  afterContainer?: React.ReactNode;
}

const PageWrapper: React.FC<PageWrapperProps> = ({
  title,
  children,
  containerClassName = '',
  afterContainer,
}) => {
  return (
    <div style={{ width: '100%' }}>
      <div className="page-wrapper">
        <h2 className="text-center mb-4 section-title">{title}</h2>
        <div className={`page-container ${containerClassName}`.trim()}>
          {children}
        </div>
        {afterContainer}
      </div>
    </div>
  );
};

export default PageWrapper; 
